import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import { router } from './router'
import './styles.css'
import { startSyncLoop } from './lib/sync'
import { setNativeNavigate } from './lib/native'
import { i18n, applyOdooLang } from './i18n'
import { getTokens } from './lib/db'
// Registrar el listener global de beforeinstallprompt antes de montar Vue.
// El evento se dispara muy temprano al cargar la PWA; si esperamos a que
// Home.vue se monte, lo perdemos.
import '@/lib/install'

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(i18n)
app.mount('#app')

// Idioma automático por empleado: aplicamos el idioma guardado del onboard
// (lo devuelve la API en user.lang) en cuanto arranca la app. Para los árabes
// activa además RTL. Si no hay sesión todavía, queda en español por defecto.
getTokens()
  .then((t) => applyOdooLang(t?.lang))
  .catch(() => {})

// Permite que el push (al tocar la notificación de un pedido) abra /pedidos.
setNativeNavigate((path) => router.push(path))

// CI/CD live since 2026-05-18 — pushes to main auto-deploy to server A.
startSyncLoop()
